import { Portal } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/query-params';

import * as S from './TrackingToast.styles';
import { AlertsInsightCard } from '~/modules/alerts-card/components/alerts-insight-card/AlertsInsightCard';

export interface TrackingToastContentProps {
  insightId: string;
}

export const TrackingToastContent = ({
  insightId,
}: TrackingToastContentProps) => {
  const { t } = useTranslation('insights');
  const { params } = useQueryParams();

  const relation = params[queryKeys.insightRelation];

  return (
    <Portal>
      <S.ToastPositioner>
        <S.ToastRoot data-testid="tracking-toast">
          <AlertsInsightCard
            alertEvent={{
              source_id: insightId,
              title: t('insights:drawer.trackingConfirmation'),
              relation: relation ?? undefined,
            }}
            variant="toast"
          />
        </S.ToastRoot>
      </S.ToastPositioner>
    </Portal>
  );
};
